module.exports = __webpack_public_path__ + "static/media/avast-logo.c001d305.png";